import React from 'react'
import { connectionStateColors } from '../../theme'
import Tag from '../atoms/tag'

export function ConnectionStateTag({ connectionState, small=false }) {
  let color = connectionStateColors.default
  if('Connected' === connectionState)
    color = connectionStateColors.connected

  if('Disconnected' === connectionState)
    color = connectionStateColors.disconnected

  return (
    <Tag
      color={color}
      title={connectionState ?? 'Unknown'}
      titleFontSize={14} />
  )
}